module.exports = __webpack_public_path__ + "img/app.4f04b100.svg";